import React from 'react';
import { Loader2 } from 'lucide-react';
import { organisateurApi, PortailInfo } from '../../../lib/organisateurApi';
import { Textarea } from '../../ui/Field';
import { SURTITRE, pillPrimary } from '../../ui/pills';

const MAX = 180;

/**
 * 19b — les deux cartes du bas. « Contraintes alimentaires » : un NOMBRE, et la phrase qui dit pourquoi
 * rien de plus (données de santé, elles restent entre le convive et la cuisine). « Votre mot d'accueil » :
 * 180 caractères, inséré en haut de la page de chaque convive — le reste du courriel est rédigé par
 * l'établissement.
 */
export function OrganisateurCartes({ token, info, onMotAccueil }: { token: string; info: PortailInfo; onMotAccueil: (m: string) => void }) {
    const [mot, setMot] = React.useState(info.mot_accueil || '');
    const [enregistrement, setEnregistrement] = React.useState(false);
    const [erreur, setErreur] = React.useState('');
    React.useEffect(() => { setMot(info.mot_accueil || ''); }, [info.mot_accueil]);
    const modifie = mot.trim() !== (info.mot_accueil || '').trim();
    const nomEtab = info.etablissement?.name || "l'établissement";

    const enregistrer = async () => {
        setEnregistrement(true);
        setErreur('');
        const r = await organisateurApi.motAccueil(token, mot.trim());
        setEnregistrement(false);
        if (!r.ok) { setErreur(r.data.error || "Le mot d'accueil n'a pas été enregistré."); return; }
        onMotAccueil(r.data.mot_accueil || '');
    };

    return (
        <div className="grid grid-cols-[repeat(auto-fit,minmax(290px,1fr))] gap-3 items-start">
            <div className="px-4 py-[15px] rounded-xl bg-surface border border-border">
                <div className={`${SURTITRE} mb-2.5`}>Contraintes alimentaires</div>
                <div className="flex items-baseline gap-1.5">
                    <span className="text-[25px] font-bold tracking-[-0.02em] tabular-nums leading-none text-content">{info.contraintes}</span>
                    <span className="text-[12px] text-content-muted">convive{info.contraintes > 1 ? 's' : ''} concerné{info.contraintes > 1 ? 's' : ''}</span>
                </div>
                <p className="mt-[9px] text-[12px] leading-[1.5] text-content-muted text-pretty">
                    Prises en charge directement par {nomEtab}. Les détails ne sont pas affichés ici : ce sont des données de santé, elles restent entre le convive et la cuisine.
                </p>
            </div>
            <div className="px-4 py-[15px] rounded-xl bg-surface border border-border">
                <div className="flex items-baseline justify-between gap-2.5 flex-wrap gap-y-1 mb-2.5">
                    <span className={SURTITRE}>Votre mot d'accueil</span>
                    <span className={`text-[11.5px] ${mot.length >= MAX ? 'text-state-warn font-semibold' : 'text-content-muted'}`}>{mot.length} / {MAX} caractères</span>
                </div>
                <Textarea value={mot} maxLength={MAX} rows={3} placeholder="Merci de choisir votre plat avant la date indiquée. Pour toute question, appelez-nous plutôt que de répondre à ce courriel."
                    onChange={(e) => setMot(e.target.value.slice(0, MAX))} className="!text-[12.5px] !leading-[1.55]" />
                <div className="flex items-start justify-between gap-3 mt-[7px]">
                    <p className="text-[11.5px] text-content-muted text-pretty">S'affiche en haut de la page de vos convives. Le reste du message est rédigé par l'établissement.</p>
                    {modifie && (
                        <button type="button" onClick={enregistrer} disabled={enregistrement} className={pillPrimary(32)}>
                            {enregistrement ? <Loader2 size={12} className="animate-spin" /> : null} Enregistrer
                        </button>
                    )}
                </div>
                {erreur && <p className="mt-1.5 text-[12px] font-semibold text-state-danger">{erreur}</p>}
            </div>
        </div>
    );
}
